__turbopack_context__.v({
  "letter": "Vwf1GW_letter",
  "slideUp": "Vwf1GW_slideUp",
  "wordEnter": "Vwf1GW_wordEnter",
  "wordEnterActive": "Vwf1GW_wordEnterActive",
  "wordEnterComplete": "Vwf1GW_wordEnterComplete",
  "wordEnterCompleteActive": "Vwf1GW_wordEnterCompleteActive",
  "wordExit": "Vwf1GW_wordExit",
  "wordExitActive": "Vwf1GW_wordExitActive",
  "wordExitComplete": "Vwf1GW_wordExitComplete",
  "wordExitCompleteActive": "Vwf1GW_wordExitCompleteActive",
});
